import React, { Fragment } from 'react';
import { bool, object, string } from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';

import { PdpSharedDealerDistinctions } from '../PdpSharedDealerDistinctions/PdpSharedDealerDistinctions';
import { PdpSharedDealerInfo } from '../PdpSharedDealerInfo/PdpSharedDealerInfo';
import { PdpSharedStarRating } from '../PdpSharedStarRating/PdpSharedStarRating';
import { PdpSharedDealerDetailsHeader } from '../PdpSharedDealerDetailsHeader/PdpSharedDealerDetailsHeader';
import { PdpRespDealerDetailsBio } from '../PdpSharedDealerDetailsBio/PdpRespDealerDetailsBio';

import styles from './PdpSharedDealerDetailsStats.scss';

const PdpRespDealerDetailsStatsComponent = props => {
    const { reviews, seller, user, showDescriptions, headerClass } = props;

    let feedbackRating = get(reviews, 'metadata.aggregatedFeedback.overallExperience.mean');
    feedbackRating = feedbackRating ? parseFloat(feedbackRating.toFixed(1)) : 0;

    return (
        <Fragment>
            <div className={styles.header}>
                <PdpSharedDealerDetailsHeader
                    headerClass={`${styles.heading} ${headerClass}`}
                    seller={seller}
                    user={user}
                />
            </div>
            <div className={styles.ratingContainer}>
                <PdpSharedStarRating feedbackRating={feedbackRating} />
            </div>
            <PdpRespDealerDetailsBio seller={seller} />
            <PdpSharedDealerDistinctions seller={seller} showDescriptions={showDescriptions} />
            <div className={styles.companyInfo}>
                <PdpSharedDealerInfo seller={seller} />
            </div>
        </Fragment>
    );
};

PdpRespDealerDetailsStatsComponent.defaultProps = {
    showDescriptions: false,
};

PdpRespDealerDetailsStatsComponent.propTypes = {
    seller: object.isRequired,
    user: object,
    reviews: object,
    showDescriptions: bool,
    headerClass: string,
};

export const PdpRespDealerDetailsStats = createFragmentContainer(
    PdpRespDealerDetailsStatsComponent,
    {
        seller: graphql`
            fragment PdpRespDealerDetailsStats_seller on Seller {
                ...PdpSharedDealerDistinctions_seller
                ...PdpSharedDealerInfo_seller
                ...PdpSharedDealerDetailsHeader_seller
                ...PdpMobileStarRating_seller
                ...PdpRespDealerDetailsBio_seller
            }
        `,
        user: graphql`
            fragment PdpRespDealerDetailsStats_user on User {
                ...PdpSharedDealerDetailsHeader_user
            }
        `,
        reviews: graphql`
            fragment PdpRespDealerDetailsStats_reviews on SellerOrderFeedbackPdpQueryConnection {
                metadata {
                    aggregatedFeedback {
                        overallExperience {
                            mean
                        }
                    }
                }
            }
        `,
    }
);
